import { ComponentChildren } from "preact";
import { getText } from "src/ConsentManagement/TranslationService";
import { CookieIcon } from "./CookieIcon";

type HeadingModel = {
    children?:ComponentChildren
}
export const Heading = ({children}:HeadingModel) => (
  <div class="ccm-header ccm-row">
    {CookieIcon}
    <h1 class="ccm-col title">{getText(`title`)}</h1>
    {children}
  </div>
);
